import { CollapsiblePanel, Panel } from "../../../widgets";
import { ControlType, Property, PropertyType } from "../../../base/types";

import { DocumentChecklist } from "./DocumentChecklist";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { useGetProperties } from "../../../base/hooks";

export const DocumentChecklistComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const entityId: string | undefined = properties[Property.EntityId];
    const entity: string | undefined = properties[Property.Entity]
    const checklistId: string | undefined = properties[Property.ChecklistId]
    const title: string | undefined = properties[Property.Title]
    const headerClass: string | undefined = properties[Property.HeaderClass]
    const collapsible: boolean | undefined = properties[Property.Collapsible]
    const relativePath: string | undefined = properties[Property.RelativePath]

    if (collapsible) {
        return (
            <CollapsiblePanel
                eventKey="checklist"
                header={title}
                icon="FactCheckOutlined"
                headerClass={headerClass}
                className={className}>
                {(checklistId) && <>
                    <DocumentChecklist
                        entityId={entityId}
                        entity={entity}
                        relativePath={relativePath}
                        checklistId={checklistId} />
                </>}
            </CollapsiblePanel>
        )
    }

    return (
        <Panel
            header={title}
            icon="FactCheckOutlined"
            headerClass={headerClass}
            className={className}>
            {(checklistId) && <>
                <DocumentChecklist
                    entityId={entityId}
                    entity={entity}
                    relativePath={relativePath}
                    checklistId={checklistId} />
            </>}
        </Panel>)
}

Registry.addControl({
    id: "3529d1e9-1def-4efd-9289-489da1763130",
    name: "Document Checklist",
    type: ControlType.DocumentChecklist,
    properties: [
        { id: Property.Title, name: 'Title', type: PropertyType.String },
        { id: Property.Entity, name: 'Entity', type: PropertyType.Entity },
        { id: Property.EntityId, name: 'EntityId', type: PropertyType.String },
        { id: Property.ChecklistId, name: 'Checklist Id', type: PropertyType.String },
        { id: Property.RelativePath, name: 'Relative Path', type: PropertyType.String },
        { id: Property.Collapsible, name: 'Collapsible', type: PropertyType.Boolean },
        { id: Property.HeaderClass, name: 'Header Class', type: PropertyType.String },
    ],
    component: DocumentChecklistComponent
})
